import { is } from 'ramda'

const TIMEOUT = 60 * 1000 // 60 minutes in ms

// data structure: { version: int | undefined, subscription_params: { receipt: Base64 string, signature: Base64 string } }

export default function (googleId, params) {
  return this.sendEventWithCallback(
    'subscription.buy.android',
    {
      google_id: googleId,
      ...params,
    },
    TIMEOUT
  ).then(data => {
    // shortcut
    if (is(Object, data.subscription_params)) {
      return data
    }

    return Promise.reject(
      new Error(this.ERROR_UNKNOWN)
    )
  })
}
